// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfWeek as fn } from "../endOfWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfWeek = convertToFP(fn, 1);

// Fallback for modularized imports:
export default endOfWeek;
